export default "__VITE_ASSET__816d9b8b__"